<template src="./html/Datatable.html"></template>

<script>
	import swal from 'sweetalert2'
	import Vuetable from 'vuetable-2/src/components/Vuetable'
	import VuetablePaginationInfo from 'vuetable-2/src/components/VuetablePaginationInfo'
	import VuetablePagination from 'vuetable-2/src/components/VuetablePagination'

	import Create from './Create'
	import Edit from './Edit'
	import VueElementLoading from 'vue-element-loading'
	import Actions from './Actions'

	export default {
		props: ['isAuth', 'user'],
		components: {
			'datatable': Vuetable,
			'pagination-info': VuetablePaginationInfo,
			'pagination': VuetablePagination,

			'create': Create,
			'edit': Edit,
			'loading': VueElementLoading,
			'actions': Actions,
		},
		data () {
			return {
				perPages: [
					{
						label: 20,
						value: 20,
					},
					{
						label: 50,
						value: 50,
					},
					{
						label: 100,
						value: 100,
					},
					{
						label: 'Todo',
						value: null,
					},
				],
				datatable: {
					api: this.$env.ROOT + '/api/' + this.$lang.getLang() + '/admin/management/products/categories/datatable',
					loading: true,
					moreParams: {
						filter: {
							text: null,
							allowDate: false,
							date: null,
						},
					},
					page: 100,
					path: '',
					sortOrder: [
						{
							field: 'created_at',
							sortField: 'created_at',
							direction: 'desc',
						}
					],
					options: {
						headers: {
							'Authorization': 'Bearer ' + this.$auth.getToken()
						}
					},
					css: {
						table: {
							sortableIcon: 'fa fa-sort',
							tableClass: 'table table-hover table-striped table-condensed',
							ascendingIcon: 'fa fa-caret-up',
							descendingIcon: 'fa fa-caret-down',
						},
						pagination: {
							wrapperClass: "pagination pull-right",
							activeClass: "btn-default disabled",
							disabledClass: "disabled",
							pageClass: "btn btn-default",
							linkClass: "btn btn-default",
							icons: {
								first: "fa fa-fast-backward",
								prev: "fa fa-step-backward",
								next: "fa fa-step-forward",
								last: "fa fa-fast-forward",
							}
						},
					},
					fields: [
						{
							name: 'id',
							title: this.$platform.setting.number_symbol,
							sortField: 'id',
						},
						{
							name: '__slot:title',
							title: 'Título',
							sortField: 'title',
						},
						{
							name: '__slot:private',
							title: 'Privado',
							sortField: 'private',
						},
						{
							name: '__slot:lang',
							title: 'Idioma',
							sortField: 'lang',
						},
						{
							name: '__slot:parent',
							title: 'Padre',
						},
						{
							name: '__slot:sort',
							title: 'Orden',
							sortField: 'sort',
						},
						{
							name: '__slot:status',
							title: 'Estado',
						},
						{
							name: 'created_at',
							title: 'Fecha',
							sortField: 'created_at',
							callback: function(value) {
								return moment(value).format('DD/MM/YY')
							},
						},
						{
							name: '__slot:actions',
							title: '',
						},
					],
				},
			}
		},
		methods: {
			reload() {
				this.$nextTick( () => this.$refs.datatable.refresh())
			},
			loading() {
				this.datatable.loading = true
			},
			loaded() {
				this.datatable.loading = false
				this.loadDropdowns()
			},
			onPaginationData (paginationData) {
				this.$refs.paginationInfo.setPaginationData(paginationData)
				this.$refs.pagination.setPaginationData(paginationData)
			},
			onChangePage (page) {
				this.$refs.datatable.changePage(page)
			},
			filterSet() {
				this.$nextTick( () => this.$refs.datatable.refresh())
			},
			filterReset() {
				this.$nextTick( () => this.$refs.datatable.refresh())
			},
			//--
			loadDropdowns() {
				$('.table-responsive').on('show.bs.dropdown', function () {
					$('.table-responsive').css( "overflow", "inherit" )
				});

				$('.table-responsive').on('hide.bs.dropdown', function () {
					$('.table-responsive').css( "overflow", "auto" )
				})
			},
			//--
			activate($event, item) {
				var toogle = $($event.target)
				toogle.addClass('disabled')
				this.$http.get('admin/management/products/categories/' + item.id + '/activate')
					.then(response => {
						toogle.removeClass('disabled')
						var data = response.body
						item.status_id = data.status_id
						item.status = data.status
					}).catch(response => {
						toogle.removeClass('disabled')
						if(response.status == 409) {
							swal({
								title: response.statusText,
								text: response.body,
								type: 'warning',
							})
						}
					})
			},
			deActivate($event, item) {
				var toogle = $($event.target)
				toogle.addClass('disabled')
				this.$http.get('admin/management/products/categories/' + item.id + '/deactivate')
					.then(response => {
						toogle.removeClass('disabled')
						var data = response.body
						item.status_id = data.status_id
						item.status = data.status
					}).catch(response => {
						toogle.removeClass('disabled')
						if(response.status == 409) {
							swal({
								title: response.statusText,
								text: response.body,
								type: 'warning',
							})
						}
					})
			},
			destroy: function(category) {
				var that = this
				swal.queue([{
					title: that.$t("messages.attention"),
					text: that.$t("messages.item_can_not_be_retrieved"),
					type: "warning",
					showCancelButton: true,
					confirmButtonColor: "#53e69d",
					cancelButtonColor: "#ff7676",
					confirmButtonText: "Si",
					cancelButtonText: "No",
					showLoaderOnConfirm: true,
					preConfirm: function () {
						return new Promise(function (resolve) {
							that.$http.delete('admin/management/products/categories/' + category.id)
							.then(response => {
								that.reload()
								swal(response.body.title, response.body.text, response.body.type);
							}).catch(function(response) {
								if(response.status == 409) {
									swal(response.body.title, response.body.text, response.body.type);
								} else {
									swal({
										title: response.statusText,
										text: response.body,
										type: "warning"
									});
								}
							})
						})
					}
				}]).catch(swal.noop)
			},
			sortChange($event, item) {
				var input = $($event.target)
				input.attr('disabled', true)
				this.$http.get('admin/management/products/categories/' + item.id + '/change/sort/' + item.sort)
				.then(response => {
					input.attr('disabled', false)
					this.reload()
				}).catch(function(response) {
					console.log(response)
					input.attr('disabled', false)
					this.reload()
					if(response.status == 409) {
						swal({
							title: response.body.title,
							text: response.body.text,
							type: response.body.type,
						})
					}
				})
			},
			openEdit(data) {
				this.$refs.edit.open(data)
			},
		},
	}
</script>


// WEBPACK FOOTER //
// src/components/management/productCategories/views/Datatable.vue